module.exports = __webpack_public_path__ + "img/img1.9db27b84.jpg";